import angular from "angular";

angular
    .module('api-sentinel')
    .constant('SENTINEL_API_HOST_CONSTANTS', {
        'URL': 'https://eu-ors-api.onasset.com',
        'VISION_URL': 'https://eu-insight2.onasset.com/track/',
        'AI_TRACKING_URL': 'https://oainsightai.onasset.com',
        'ERRORS': {
            'AUTHENTICATION_REQUIRED': 'AUTHENTICATION_REQUIRED'
        },
        'USER_ROLES': {
            none: 'api-none',
            all: 'api-all',
            apiAdmin: 'api-admin',
            apiAccount: 'api-account'
        }
    });
